export const getBrowseAndSearchItemIds = (products = []) => {
  return products.map(({ itemId }) => itemId);
};

export const limitProductsToDisplay = ({ products = [], setLimit = false, limitCount = 12 }) => {
  if (setLimit) { return products.slice(0, limitCount); }
  return products;
};